import ComboBox from "../../components/combobox";

export default function DefaultRolesDropdown({name, options, otherRoles}) {
  return <ComboBox name={name} options={options} label="Default Role" data={otherRoles} />;
}
